import { useCallback, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { parseDefectNavContext, buildNavUrl } from "helpers/defectNavigation";

const useDefectNavContext = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const [searchParams] = useSearchParams();

	const navContext = useMemo(
		() => parseDefectNavContext(searchParams, id),
		[searchParams, id]
	);

	const hasPrevious = Boolean(navContext) && navContext.pos > 0;
	const hasNext =
		Boolean(navContext) && navContext.pos < navContext.idList.length - 1;

	const goToPrevious = useCallback(() => {
		if (!navContext || navContext.pos <= 0) return;
		const prevPos = navContext.pos - 1;
		navigate(buildNavUrl(navContext, navContext.idList[prevPos], prevPos));
	}, [navContext, navigate]);

	const goToNext = useCallback(() => {
		if (!navContext || navContext.pos >= navContext.idList.length - 1) return;
		const nextPos = navContext.pos + 1;
		navigate(buildNavUrl(navContext, navContext.idList[nextPos], nextPos));
	}, [navContext, navigate]);

	return { navContext, hasPrevious, hasNext, goToPrevious, goToNext };
};

export default useDefectNavContext;
